<template>
  <div class="popup-container">
    <div @click="closePopup" class="scrim"></div>
    <div class="popup-dialog">
      <md-progress-bar
        v-if="loading"
        md-mode="indeterminate"
        class="progress-bar"
      ></md-progress-bar>
      <div class="popup">
        <div class="scrim-white" v-if="loading"></div>
        <div class="flex justify-end">
          <button @click="closePopup" class="close-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div class="popup__content">
          <form @submit.prevent="handleFormSubmit">
            <span class="question text-center"
              >Receive this<br class="break"/>
              information by email</span
            >
            <!-- <input-component class="mt-5">
              <input type="text" placeholder="Email*" v-model="email" />
            </input-component> -->
            <input-component
              class="mt-10 mb-6"
              name="email"
              label="Email*"
              v-model="email"
              required
              type="email"
              ref="email-input"
              inputmode="email"
            ></input-component>
            <privacy-consent
                class="pl-2 sm:pl-1"
                v-bind:checked.sync="privacyConsent"
            ></privacy-consent>
            <p v-if="error" class="text-center mt-10">Something went wrong. Please try again.</p>
            <button
              :disabled="formIsInvalid"
              class="send-button btn btn-primary"
              :class="{ disabled: formIsInvalid }"
            >
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vhCheck from "vh-check";
import { mapActions, mapGetters, mapMutations } from "vuex";
import InputComponent from "./forms/InputComponent";
import PrivacyConsent from "./PrivacyConsent";
import { ACTIONS, GETTERS, MUTATIONS } from "../../store/wizard/types";

const check = vhCheck({
  updateOnTouch: true,
});

export default {
  components: {
    InputComponent,
    PrivacyConsent,
  },
  data: () => ({
    email: "",
    error: false,
    errorTimeout: null,
    privacyConsent: false,
  }),
  computed: {
    ...mapGetters({
      loading: GETTERS.GET_LOADING,
    }),
    formIsInvalid() {
      const inputComponent = this.$refs["email-input"];
      return (
        !this.email ||
        !inputComponent.$refs.input.checkValidity() ||
        !this.privacyConsent
      );
    },
  },
  methods: {
    ...mapMutations({
      setLoadingToFalse: MUTATIONS.SET_LOADING_TO_FALSE,
    }),
    ...mapActions({
      sendEmailAction: ACTIONS.SEND_EMAIL,
    }),
    handleFormSubmit() {
      if (!this.formIsInvalid) {
        this.sendEmail();
      }
    },
    sendEmail() {
      clearTimeout(this.errorTimeout);
      this.error = false;
      this.sendEmailAction(this.email)
        .then(() => {
          setTimeout(() => {
            this.setLoadingToFalse();
          }, 1500);
          // Send a message to the parent page for redirection
          window.parent.postMessage('emailSentAction.send_by_email', '*');
          // this.$router.replace({ name: "email-sent" });
        })
        .catch(() => {
          this.setLoadingToFalse();
          this.error = true;
          this.errorTimeout = setTimeout(() => (this.error = false), 5000);
        });
    },
    closePopup() {
      !this.loading && this.$emit("close-popup");
    },
  },
  destroyed() {
    check.unbind();
  },
};
</script>

<style lang="scss">
@import "../../../sass/variables";

.popup-container {
  z-index: -1;
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  height: calc(100vh - var(--vh-offset, 0px));
  width: 100%;
  opacity: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 1rem;

  &.open {
    opacity: 1;
    z-index: 2000;
    .popup-dialog {
      transform: scale(1);
    }
  }

  .scrim {
    z-index: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }

  .popup-dialog {
    width: 100%;
    max-width: 600px;
    transform: scale(0.8);
    position: relative;
    transition: transform 0.5s;
    display: flex;
    flex-direction: column;

    .progress-bar {
      background-color: rgba($color: $primary, $alpha: 0.5) !important;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;

      .md-progress-bar-fill {
        &:after {
          background-color: $primary !important;
        }
      }
      .md-progress-bar-track {
        &:after {
          background-color: $primary !important;
        }
      }
    }

    .popup {
      position: relative;
      background-color: rgba($color: #ffffff, $alpha: 1);
      padding: 17px;
      .scrim-white {
        position: absolute;
        background: rgba(#ffffff, 0.6);
        width: 100%;
        height: 100%;
        left: 0;
        bottom: 0;
      }

      &__content {
        padding: 27px 73px 47px 73px;
        @media (max-width: $md) {
          padding: 27px 0;
        }

        form {
          display: flex;
          flex-direction: column;

          .question {
            font-size: 25px;
            line-height: 1.58;

            .break {
              display: none;
              @media (min-width: 400px) {
                display: inline;
              }
            }
          }

          .custom-input, .privacy-consent-component {
            max-width: 400px;
            margin: auto;
          }
        }
      }

      .close-button {
        width: 30px;
        height: 30px;
        color: lightgray;
        &:hover {
          color: black;
        }
      }

      .send-button {
        width: 175px;
        margin: auto;
        margin-top: 50px;
      }
    }
  }
}
</style>
